import React from 'react'
import {Button, Label, Pane, SelectField} from "evergreen-ui";
import {useDispatch} from "react-redux";
import {findFirstByCode, findFirstByName} from "../../common/matchMethods";
import {
    getCodesByStationAndDatasourceType,
    getEntitiesByStationAndDatasourceTypeId
} from "../../decadeConstructor/ApiCalls";
import {datasourceTypeObject} from "../../common/constructorObject";

export default function FilterPairRow({
    isFullWindow,
    constructor,
    canSelect,
    rowNum,
    possibleDatasourceTypes,
    onDeleteFilter,
    onSelectDatasourceTypeForLevel,
    onSelectCodeForLevel,
    onSelectDatasourceTypeForRainfall,
    onSelectCodeForRainfall,
    onSelectEntityForLevel,
    onSelectEntityForRainfall
}) {
    const dispatch = useDispatch();

    const innerTypesForDatasource = possibleDatasourceTypes !== null && possibleDatasourceTypes.length !== 0 ? possibleDatasourceTypes : []
    const rainfall = constructor.filters[rowNum].rainfall
    const level = constructor.filters[rowNum].level

    const isRainfallDatasourceTypeSelected = rainfall.type.id !== -1 || rainfall.type.id == undefined
    const isLevelDatasourceTypeSelected = level.type.id !== -1 || level.type.id == undefined

    const [isRainfallCodeSelected, setIsRainfallCodeSelected] = React.useState(
        rainfall.code.code !== '' && rainfall.code.code !== undefined
    )
    const [isLevelCodeSelected, setIsLevelCodeSelected] = React.useState(
        level.code.code !== '' && level.code.code !== undefined
    )
    const [levelCodeChanged, setLevelCodeChanged] = React.useState(false)
    const [rainfallCodeChanged, setRainfallCodeChanged] = React.useState(false)
    const [possibleCodesForRainfall, setPossibleCodesForRainfall] = React.useState(rainfall.type.codes)
    const [possibleEntitiesForRainfall, setPossibleEntitiesForRainfall] = React.useState(rainfall.code.entities)

    const [rainfallCodesLoading, setRainfallCodesLoading] = React.useState(possibleCodesForRainfall == undefined)
    const [rainfallEntitiesLoading, setRainfallEntitiesLoading] = React.useState(possibleEntitiesForRainfall == undefined)

    const [possibleCodesForLevel, setPossibleCodesForLevel] = React.useState(level.type.codes)
    const [possibleEntitiesForLevel, setPossibleEntitiesForLevel] = React.useState(level.code.entities)

    const [levelCodesLoading, setLevelCodesLoading] = React.useState(possibleCodesForLevel == undefined)
    const [levelEntitiesLoading, setLevelEntitiesLoading] = React.useState(possibleEntitiesForLevel == undefined)

    const smthIsLoading = rainfallCodesLoading || rainfallEntitiesLoading || levelCodesLoading || levelEntitiesLoading

    if (rainfallCodesLoading) {

        let res = findFirstByName(innerTypesForDatasource, rainfall.type.name)

        getCodesByStationAndDatasourceType(constructor.station.id, res.id).then((response) => {
            setPossibleCodesForRainfall(response.data)
            setRainfallCodesLoading(false)
        })
    }

    if (rainfallEntitiesLoading) {
        getEntitiesByStationAndDatasourceTypeId(constructor.station.id, rainfall.type.id).then((response) => {
            setPossibleEntitiesForRainfall(response.data.sort((a,b) => a.id - b.id))
            setRainfallEntitiesLoading(false)
        })
    }

    if (levelCodesLoading) {
        let res = findFirstByName(innerTypesForDatasource, level.type.name)

        getCodesByStationAndDatasourceType(constructor.station.id, res.id).then((response) => {
            setPossibleCodesForLevel(response.data)
            setLevelCodesLoading(false)
        })
    }

    if (levelEntitiesLoading) {
        getEntitiesByStationAndDatasourceTypeId(constructor.station.id, level.type.id).then((response) => {
            setPossibleEntitiesForLevel(response.data.sort((a,b) => a.id - b.id))
            setLevelEntitiesLoading(false)
        })
    }

    function handleDatasourceTypeForRainfall(name) {
        if (name == -1) {
            let res = {...datasourceTypeObject}
            dispatch(onSelectDatasourceTypeForRainfall({res, rowNum}))
            return
        }

        let res = findFirstByName(innerTypesForDatasource, name)

        getCodesByStationAndDatasourceType(constructor.station.id, res.id).then((result) => {
            res = {id: res.id, name: res.name, codes: result.data}
            setPossibleCodesForRainfall(result.data)
            dispatch(onSelectDatasourceTypeForRainfall({res, rowNum}))
            setIsRainfallCodeSelected(false)
            setRainfallCodeChanged(true)
        })

    }

    function handleCodeForRainfall(code) {
        let res = findFirstByCode(possibleCodesForRainfall, code)

        getEntitiesByStationAndDatasourceTypeId(constructor.station.id, rainfall.type.id).then((result) => {
            res = {id: res.id, code: res.code, entities: result.data}
            setPossibleEntitiesForRainfall(result.data)
            dispatch(onSelectCodeForRainfall({res, rowNum}))
            setIsRainfallCodeSelected(true)
            setRainfallCodeChanged(false)
        })
    }

    function handleEntityForRainfall(name) {
        let res = findFirstByName(possibleEntitiesForRainfall, name)
        dispatch(onSelectEntityForRainfall({res, rowNum}))
    }

    function handleDatasourceTypeForLevel(name) {
        if (name == -1) {
            let res = {...datasourceTypeObject}
            dispatch(onSelectDatasourceTypeForLevel({res, rowNum}))
            return
        }

        let res = findFirstByName(innerTypesForDatasource, name)
        getCodesByStationAndDatasourceType(constructor.station.id, res.id).then((result) => {
            res = {id: res.id, name: res.name, codes: result.data}
            setPossibleCodesForLevel(result.data)
            dispatch(onSelectDatasourceTypeForLevel({res, rowNum}))
            setIsLevelCodeSelected(false)
            setLevelCodeChanged(true)
        })
    }

    function handleCodeForLevel(code) {
        let res = findFirstByCode(possibleCodesForLevel, code)

        getEntitiesByStationAndDatasourceTypeId(constructor.station.id, level.type.id).then((result) => {
            res = {id: res.id, code: res.code, entities: result.data}
            setPossibleEntitiesForLevel(result.data)
            dispatch(onSelectCodeForLevel({res, rowNum}))
            setIsLevelCodeSelected(true)
            setLevelCodeChanged(false)
        })
    }

    function handleEntityForLevel(name) {
        let res = findFirstByName(possibleEntitiesForLevel, name)
        dispatch(onSelectEntityForLevel({res, rowNum}))
    }

    if (smthIsLoading) {
        return (
            <></>
        );
    }

    return (
        <Pane marginBottom={6} alignItems={"top"}>
            <Pane display="flex" columnGap={25} >
                <Pane verticalAlign={"top"}>
                    <SelectField
                        label={"Тип источника (слой осадков)"}
                        width={290}
                        onChange={e => handleDatasourceTypeForRainfall(e.target.value)}
                        value={rainfall.type.name}
                        marginTop={-4.5}
                        disabled={!canSelect}
                    >
                        <option value={-1}>Выберите тип источника</option>
                        {innerTypesForDatasource.map((type) => <option key={type.name} value={type.name}>{type.name}</option>)}
                    </SelectField>
                </Pane>

                <Pane verticalAlign={"top"}>
                    <SelectField
                        label={"Метеокод (слой осадков)"}
                        disabled={!canSelect || !isRainfallDatasourceTypeSelected}
                        width={180}
                        onChange={e => handleCodeForRainfall(e.target.value)}
                        value={rainfallCodeChanged ? "Выберите метеокод" : rainfall.code.code}
                        marginTop={-4.5}
                    >
                        <option value={-1}>Выберите метеокод</option>
                        {possibleCodesForRainfall.map((ent) => <option key={ent.code} value={ent.code}>{ent.code}</option>)}
                    </SelectField>
                </Pane>
                <Pane verticalAlign={"top"}>
                    <SelectField
                        label={"Пункт наблюдения (слой осадков)"}
                        width={240}
                        value={!isRainfallCodeSelected ? "Выберите пункт наблюдения" : rainfall.stnEntity.name}
                        onChange={e => handleEntityForRainfall(e.target.value)}
                        marginTop={-4.5}
                        disabled={!canSelect || !isRainfallCodeSelected}
                    >
                        <option value={-1}>Выберите пункт наблюдения</option>
                        {possibleEntitiesForRainfall.filter((ent) => ent.typeCode !== "DEVICE")
                            .map((ent) => <option key={ent.name} value={ent.name}>{ent.name}</option>)}
                    </SelectField>
                </Pane>

                {
                    rowNum !== 0 && !isFullWindow ? <Button alignSelf={"center"}
                                          marginBottom={3}
                                          onClick={() => dispatch(onDeleteFilter(rowNum))}
                    >Удалить </Button> : <></>
                }
            </Pane>

            <Pane display="flex" columnGap={25} >
                <Pane verticalAlign={"top"}>
                    <SelectField
                        label={"Тип источника (уровень воды)"}
                        value={level.type.name}
                        onChange={e => handleDatasourceTypeForLevel(e.target.value)}
                        width={290}
                        marginTop={-15}
                        disabled={!canSelect}
                    >
                        <option value={-1}>Выберите тип источника</option>
                        {innerTypesForDatasource.map((type) => <option key={type.name} value={type.name}>{type.name}</option>)}
                    </SelectField>
                </Pane>

                <Pane verticalAlign={"top"}>
                    <SelectField
                        label={"Метеокод (уровень воды)"}
                        disabled={!canSelect || !isLevelDatasourceTypeSelected}
                        width={180}
                        onChange={e => handleCodeForLevel(e.target.value)}
                        value={levelCodeChanged ? "Выберите метеокод" : level.code.code}
                        marginTop={-15}
                    >
                        <option value={-1}>Выберите метеокод</option>
                        {possibleCodesForLevel.map((ent) => <option key={ent.code} value={ent.code}>{ent.code}</option>)}
                    </SelectField>
                </Pane>

                <Pane verticalAlign={"top"}>
                    <SelectField
                        label={"Пункт наблюдения (уровень воды)"}
                        disabled={!canSelect || !isLevelCodeSelected}
                        width={240}
                        onChange={e => handleEntityForLevel(e.target.value)}
                        value={!isLevelCodeSelected ? "Выберите пункт наблюдения" : level.stnEntity.name}
                        marginTop={-15}
                    >
                        <option value={-1}>Выберите пункт наблюдения</option>
                        {possibleEntitiesForLevel.filter((ent) => ent.typeCode !== "DEVICE")
                            .map((ent) => <option key={ent.name} value={ent.name}>{ent.name}</option>)}
                    </SelectField>
                </Pane>
            </Pane>

        </Pane>
    );
}
